import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { comAddPageFieldFunc, initialFiledFunc, onChangeText } from '../../../../../components/Common/validationFunction'
import { url } from '../../../../../routes'
import { loginCompanyID, loginSystemSetting } from '../../../../../components/Common/CommonFunction'

const PrefixTab = forwardRef(({ subPageMode }, ref) => {

    const fileds = {
        OrderPrefix: 'PO',
        InvoicePrefix: 'IN',
        GRNPrefix: 'GRN',
        ChallanPrefix: 'CP',
        ReceiptPrefix: 'RE',
        WorkOrderPrefix: 'WR',
        MaterialIssuePrefix: 'MI',
        DemandPrefix: 'DP',
        IBChallanPrefix: 'IBC',
        IBInwardPrefix: 'IBI',
        PurchaseReturnprefix: 'PR',
        CreditPrefix: 'CR',
        DebitPrefix: 'DR',
        Productionprefix: 'PROD',
        Wastageprefix: 'WST',
        SOPrefix: 'SO',
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))

    useImperativeHandle(ref, () => ({
        setCurrentState(arr) {
            setState(arr)
        },
        getCurrentState: () => {
            return state
        },
    }));


    const { values } = state;
    const { isError } = state;
    const { fieldLabel } = state;

    const {
        pageField,
        commonPartyDropSelect
    } = useSelector((state) => ({
        pageField: state.CommonPageFieldReducer.pageField,
        commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect
    }));



    useEffect(() => {
        if (commonPartyDropSelect.value <= 0) {
            setState((i) => {
                let a = { ...i }
                a.values.OrderPrefix = 'PO'
                a.values.InvoicePrefix = 'IN'
                a.values.GRNPrefix = 'GRN'
                a.values.ChallanPrefix = 'CP'
                a.values.ReceiptPrefix = 'RE'
                a.values.WorkOrderPrefix = 'WR'
                a.values.MaterialIssuePrefix = 'MI'
                a.values.DemandPrefix = 'DP'
                a.values.IBChallanPrefix = 'IBC'
                a.values.IBInwardPrefix = 'IBI'
                a.values.PurchaseReturnprefix = 'PR'
                a.values.CreditPrefix = 'CR'
                a.values.DebitPrefix = 'DR'
                a.values.Productionprefix = 'PROD'
                a.values.Wastageprefix = 'WST'
                a.values.SOPrefix = 'SO'

                a.hasValid.Productionprefix.valid = true;
                a.hasValid.Wastageprefix.valid = true;
                a.hasValid.OrderPrefix.valid = true;
                a.hasValid.InvoicePrefix.valid = true;
                a.hasValid.GRNPrefix.valid = true;
                a.hasValid.ChallanPrefix.valid = true;
                a.hasValid.ReceiptPrefix.valid = true;
                a.hasValid.WorkOrderPrefix.valid = true;
                a.hasValid.MaterialIssuePrefix.valid = true;
                a.hasValid.DemandPrefix.valid = true;
                a.hasValid.IBChallanPrefix.valid = true;
                a.hasValid.IBInwardPrefix.valid = true;
                a.hasValid.PurchaseReturnprefix.valid = true;
                a.hasValid.CreditPrefix.valid = true;
                a.hasValid.SOPrefix.valid = true;
                a.hasValid.DebitPrefix.valid = true;

                return a
            })
        }
    }, [commonPartyDropSelect]);

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])


    const isManufacturingCompany = () => {
        
        const setting = loginSystemSetting()?.ManufacturingCompany || "";
        const companyIds = setting.split(",").map(Number);
        return companyIds.includes(Number(loginCompanyID()));
    };
    
    const isMfg = isManufacturingCompany();


    if (subPageMode === url.RETAILER_MASTER) {
        return null
    } return (
        <div>
            <Card className="text-black " >
                <CardBody className="c_card_body">
                    <Row>

                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.OrderPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="OrderPrefix"
                                        value={values.OrderPrefix}
                                        type="text"
                                        className={isError.OrderPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Order Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.OrderPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.OrderPrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.InvoicePrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="InvoicePrefix"
                                        value={values.InvoicePrefix}
                                        type="text"
                                        className={isError.InvoicePrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Invoice Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.InvoicePrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.InvoicePrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.GRNPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="GRNPrefix"
                                        value={values.GRNPrefix}
                                        type="text"
                                        className={isError.GRNPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter GRN Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.GRNPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.GRNPrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.ReceiptPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="ReceiptPrefix"
                                        value={values.ReceiptPrefix}
                                        type="text"
                                        className={isError.ReceiptPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Receipt Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.ReceiptPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.ReceiptPrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.PurchaseReturnprefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="PurchaseReturnprefix"
                                        value={values.PurchaseReturnprefix}
                                        type="text"
                                        className={isError.PurchaseReturnprefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Purchase Return prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.PurchaseReturnprefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.PurchaseReturnprefix}</span>
                                )}

                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.CreditPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="CreditPrefix"
                                        value={values.CreditPrefix}
                                        type="text"
                                        className={isError.CreditPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Credit prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.CreditPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.CreditPrefix}</span>
                                )}

                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.DebitPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="DebitPrefix"
                                        value={values.DebitPrefix}
                                        type="text"
                                        className={isError.DebitPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Debit prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.DebitPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.DebitPrefix}</span>
                                )}

                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.Wastageprefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="Wastageprefix"
                                        value={values.Wastageprefix}
                                        type="text"
                                        className={isError.Wastageprefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Wastage Prefix"
                                        onChange={(event) => onChangeText({ event, state, setState })}
                                    />
                                </Col>
                                {isError.Wastageprefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.Wastageprefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.SOPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="SOPrefix"
                                        value={values.SOPrefix}
                                        type="text"
                                        className={isError.SOPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Wastage Prefix"
                                        onChange={(event) => onChangeText({ event, state, setState })}
                                    />
                                </Col>
                                {isError.SOPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.SOPrefix}</span>
                                )}
                            </FormGroup>
                        </Col>


                        {isMfg && (
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.Productionprefix}</Label>
                                <Col sm={6}>
                                    <Input
                                        name="Productionprefix"
                                        value={values.Productionprefix}
                                        type="text"
                                        className={isError.Productionprefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Production Prefix"
                                        onChange={(event) => onChangeText({ event, state, setState })}
                                    />
                                </Col>
                                {isError.Productionprefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.Productionprefix}</span>
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.WorkOrderPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="WorkOrderPrefix"
                                        value={values.WorkOrderPrefix}
                                        type="text"
                                        className={isError.WorkOrderPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter WorkOrder Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>

                                {isError.WorkOrderPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.WorkOrderPrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.DemandPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="DemandPrefix"
                                        value={values.DemandPrefix}
                                        type="text"
                                        className={isError.DemandPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Demand Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>

                                {isError.DemandPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.DemandPrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.IBInwardPrefix}</Label>
                                <Col sm={6}>
                                    <Input
                                        name="IBInwardPrefix"
                                        value={values.IBInwardPrefix}
                                        type="text"
                                        className={isError.IBInwardPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter IB Inward Prefix"
                                        onChange={(event) => onChangeText({ event, state, setState })}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.IBChallanPrefix}</Label>
                                <Col sm={6}>
                                    <Input
                                        name="IBChallanPrefix"
                                        value={values.IBChallanPrefix}
                                        type="text"
                                        className={isError.IBChallanPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter IB Challan Prefix"
                                        onChange={(event) => onChangeText({ event, state, setState })}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.MaterialIssuePrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="MaterialIssuePrefix"
                                        value={values.MaterialIssuePrefix}
                                        type="text"
                                        className={isError.MaterialIssuePrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Material Issue Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>

                                {isError.MaterialIssuePrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.MaterialIssuePrefix}</span>
                                )}
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className='col col-4'>{fieldLabel.ChallanPrefix} </Label>
                                <Col sm={6}>
                                    <Input
                                        name="ChallanPrefix"
                                        value={values.ChallanPrefix}
                                        type="text"
                                        className={isError.ChallanPrefix.length > 0 ? "is-invalid form-control" : "form-control"}
                                        placeholder="Please Enter Challan Prefix"
                                        autoComplete='off'
                                        onChange={(event) => {
                                            onChangeText({ event, state, setState })
                                        }}
                                    />
                                </Col>
                                {isError.ChallanPrefix.length > 0 && (
                                    <span className="invalid-feedback">{isError.ChallanPrefix}</span>
                                )}
                            </FormGroup>
                        </Col>   )}
                        
                    </Row>
                </CardBody>
            </Card>
        </div>
    )
})

export default PrefixTab
